
import React from 'react'
import { useNavigate } from 'react-router-dom'
import Icon from '../../../components/Icon'
import { Toast } from 'antd-mobile'
import AiEmpty from "@/components/AiEmpty";
import AiPermission from '../../../components/AiPermission'
import icon_biezhen from '@/images/icon_biezhen.png'
import copyToClipboard from '../../../utils/copyToClipboard'
import telPhoneByNumber from '../../../utils/telPhoneByNumber'
import dayjs from 'dayjs'
import './index.scss'

export interface UserListProps {
    dataList: any
    isDelete?:boolean
    isEmpty?:boolean
    loading?:boolean
    onDelete?: (index:number,item:any) => void // 左上角自定义返回函数
    handleNavigate?: (item:any, index:any) => void
    isClick?:boolean
    binding?:boolean
    custom?:boolean

}

const UserList: React.FC<UserListProps> = ({isClick = true, custom = false, binding = false, loading = true, isEmpty = true, isDelete = false, dataList = [], ...props }) => {
    let navigate = useNavigate()
    const handleDelete = (index,item) => {
        if(props?.onDelete) {
            props.onDelete(index,item)
        }
    }
    const handleNavigate = (item, index) => {
        if( !isClick ) {
            return
        }
        if( binding ) {
            props?.handleNavigate && props?.handleNavigate(item, index);
            return
        }
        navigate(`/addUser?userPk=${item.userPk}&type=2`)
        props?.handleNavigate && props?.handleNavigate(item, index)
    }
    
    const handleCopy = (text) => {
        if( !text ) {
            return
        }
        copyToClipboard(text);
        Toast.show('车牌复制成功!')
    }
    const _telPhoneByNumber = (text) => {
        if( !text ) {
            return
        }
        telPhoneByNumber(text)
    }
    return (
        <div className='customer-user-wrapper-list-item-content'>
            {/* 需要显示暂无数据 且不在加载数据 且数组为空 */}
            {isEmpty && !loading && !dataList.length && <AiEmpty />}
            {dataList && !!dataList?.length && <>
                {dataList.map((item, index) => (
                    <AiPermission permission={['crm:customer:information']} key={index}>
                        <div className='customer-user-wrapper-item' onClick={() => handleNavigate(item, index)}>
                            <div className='customer-user-wrapper-list-item-content-item'>
                                <div className='content-item-portrait'>
                                    {isDelete && <span className='content-item-portrait-delete' onClick={() => handleDelete(index,item)}><Icon icon="&#xe71a;" /></span>}
                                    {item.face ? <img className='content-item-portrait-img' src={item.face} alt="" /> : <Icon icon="&#xe719;" style={{ fontSize: '.96rem', color: '#ddd',padding:0 }} />}
                                    {!!item.vipTypeIcon && <img className='content-item-portrait-vip' src={item.vipTypeIcon} alt="" />}
                                    <p>{item.userInfoFinishRate || 0}%</p>
                                </div>
                                <div className='content-item-information'>
                                    <div className='content-item-information-user-information'>
                                        <div className='user-information-wrapper'><b>{item.name || item.nickName}</b><i onClick={(event) => {
                                                event.stopPropagation();
                                                _telPhoneByNumber(item.phone)
                                            }}>{item.phone}</i></div>
                                        {!item.lastInStoreTime && item.noInstoreDay === -1 && <p className='user-consumption-wrapper'>未到店</p>}
                                        {item.lastInStoreTime && <p className='user-consumption-wrapper'>上次进店: {dayjs(item.lastInStoreTime).format('YYYY-MM-DD')} (距今{item.noInstoreDay}天)</p>}
                                    </div>
                                    <div className='content-item-information-vehicle-information'>
                                        <div style={{ flex: '1.066667rem 0 0', display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingRight: '.16rem' }}>
                                            <Icon icon="&#xe70c;" style={{ fontSize: '.373333rem', color:item.wxMpStatus === '1' ? '#00C662' : '#C2C4CA', padding: '0' }} />
                                            <Icon icon="&#xe70f;" style={{ fontSize: '.373333rem', color:item.status === '1' ? '#00C662' : '#C2C4CA', padding: '0' }} />
                                        </div>
                                        <div className='license-plate-wrapper'>
                                            {item?.carList && !!item?.carList?.length && <p>{item?.carList[0].icon && <img src={item?.carList[0].icon} alt="" />}<b onClick={(event) => {
                                                event.stopPropagation();
                                                handleCopy(item.carNo)
                                            }}>{item?.carList[0].carNo}</b></p>}
                                            {item?.carList?.length > 1 && <h1>...{item?.carList?.length}</h1>}
                                            { !item?.carList?.length && <div className='license-plate-wrapper-biezhen'><img src={icon_biezhen} alt=""/> <i>绑定车辆</i> </div>}
                                        </div>
                                        <div className='license-plate-wrapper-consumption'>
                                            <div><Icon icon='&#xe762;' style={{'color':'#FE8727'}} />共<b className='consumption-color' style={{'color':'#FE8727'}}>{item.cardCount || 0}</b>张 余<b className='consumption-color' style={{'color':'#FE8727'}}>{item.cardUsableNumber || 0}</b>次</div>
                                            <div>余额<b className='consumption-color' style={{'color':'#FE8727'}}>{item.cardBalanceAmount || 0}</b><b className='consumption-color' style={{'fontWeight':'normal'}}>元</b></div>
                                        </div>
                                    </div>
                                    <div className='content-item-information-vehicle-information'>
                                        {item?.lostStatus == 1 && <p className='lost-status'>已流失</p>}
                                        {!!item.consumeType && <div className='license-label-wrapper'>
                                            {!!item.consumeType && (item.consumeType.split(',').filter((i,o) => o < 3)).map((itemName, index) => (
                                                <span key={index}>{itemName}</span>
                                            ))}
                                            {!!item?.consumeType && item.consumeType.split(',')?.length > 3 && <h1>...{item.consumeType.split(',')?.length}</h1>}
                                        </div>}
                                        <div className='license-plate-wrapper-consumption'>
                                            <div><Icon icon='&#xe766;' style={{'color':'#B68D41'}} />共<b className='consumption-color' style={{'color':'#B68D41'}}>{item.consumeCardCount || 0}</b>张</div>
                                            <div>余额<b className='consumption-color' style={{'color':'#B68D41'}}>{item.consumeCardBalanceAmount || 0}</b><b className='consumption-color' style={{'fontWeight':'normal','color':'#B68D41'}}>元</b></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='how-many-wrapper'>
                                <div className='how-many-wrapper-qun'>
                                    {(!item.lastEntryGroupDate || !item?.entryGroupCount) && <div>未进入车辆服务直播间</div>}
                                    {item.lastEntryGroupDate && item.entryGroupCount && <><div>进服务大厅<b className='consumption-color'>{item.entryGroupCount}</b>次</div>
                                    <div>最近一次进服务大厅: {item.lastEntryGroupDate}  (距今{item.lastEntryGroupDays}天)</div></>}
                                </div>
                                <div className='how-many-wrapper-content'>
                                    <div className='license-plate-wrapper-consumption'>
                                        <div>共到店<b style={{'--color':'#21C69B'}}>{item.inStoreCount}</b>次</div>
                                        <div>总消费<b style={{'--color':'#828384'}}>{item.consumeAmount}</b>元</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </AiPermission>
                ))}
            </>}
        </div>
    )
}

export default UserList